import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css"; // Pastikan huruf besar jika nama filenya Navbar.css

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => {
        setIsOpen(false);
        window.scrollTo(0, 0);
    };

    return (
        <>
            <nav className="navbar">
                <div className="nav-container">
                    {/* HAMBURGER (Kiri) */}
                    <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    {/* LOGO (Tengah) */}
                    <div className="logo" onClick={() => { navigate("/"); closeMenu(); }}>
                        <div className="logo-img">
                            <img src="/logo-rony.png" alt="Logo" />
                        </div>
                        <span className="logo-text">
                            XYRONS <span>HUB</span>
                        </span>
                    </div>

                    {/* SPACER (Kanan - agar logo tetap di tengah) */}
                    <div className="nav-spacer"></div>
                </div>

                {/* RUNNING TEXT (Terkunci di bawah Logo) */}
                <div className="marquee-container">
                    <div className="marquee-content">
                        🚀 XYRONS COMMUNITY HUB • 30+ AI TOOLS ONLINE • MEDAN - SIHANOUKVILLE CONNECTION • WELCOME RONY SAPUTRA • SHARE YOUR AI IDEAS BELOW!
                    </div>
                </div>
            </nav>

            {/* SIDEBAR MENU (Muncul dari Samping Kiri) */}
            <div className={`sidebar-menu ${isOpen ? "active" : ""}`}>
                <div className="sidebar-links">
                    <Link to="/" onClick={closeMenu}>HOME</Link>
                    <Link to="/community" onClick={closeMenu}>COMMUNITY</Link>
                    <Link to="/courses" onClick={closeMenu}>EDUCATION</Link>
                    <Link to="/blog" onClick={closeMenu}>BLOG</Link>
                    <Link to="/portfolio" onClick={closeMenu}>PORTFOLIO</Link>
                    <Link to="/profile" onClick={closeMenu}>PROFILE</Link>
                    <Link to="/about" onClick={closeMenu}>ABOUT</Link>
                </div>
            </div>

            {/* Overlay untuk menutup menu saat klik di luar */}
            {isOpen && <div className="overlay" onClick={closeMenu}></div>}
        </>
    );
}